(ns app.front.ui.sticky
  (:require [react]
            [reagent.core :as r]))


(defonce sticky-context (react/createContext "sticky"))
(def Provider (.-Provider sticky-context))


(defn scroller [_ & _]
  (r/with-let
    [*ref             (atom nil)
     *stickies        (r/atom #{})
     *scroll-top      (r/atom 0)
     *scroll-height   (r/atom 0)
     order-stickies   (fn [stickies] (->> stickies vec (map deref) (sort-by (fn [el] (.-offsetTop el)))))
     order-stickies-m (memoize order-stickies)
     ordered-stickies #(order-stickies-m @*stickies)
     heights-before   #(->> (ordered-stickies)
                            (take (.indexOf (ordered-stickies) %))
                            (reduce (fn [total el] (+ total (.-offsetHeight el))) 0))
     heights-after    #(->> (ordered-stickies)
                            (drop (.indexOf (ordered-stickies) %))
                            (reduce (fn [total el] (+ total (.-offsetHeight el))) 0))
     add-sticky       (fn [sticky]
                        (reset! *stickies (conj @*stickies sticky)))
     remove-sticky    (fn [sticky]
                        (reset! *stickies (disj @*stickies sticky)))
     on-update        (fn []
                        (let [scroll-top    (.-scrollTop @*ref)
                              scroll-height (.-clientHeight @*ref)]
                          (reset! *scroll-top scroll-top)
                          (reset! *scroll-height scroll-height)))
     add-listeners    (fn [_]
                        (on-update)
                        (js/window.addEventListener "resize" on-update))
     remove-listeners (fn [_]
                        (js/window.removeEventListener "resize" on-update))
     scroll-to        (fn [top]
                        (.scrollTo @*ref #js {:top top :behavior "smooth"})
                        nil)]
    (r/create-class
      {:component-did-mount    add-listeners
       :component-will-unmount remove-listeners
       :component-did-update   on-update
       :reagent-render         (fn [props & children]
                                 (r/create-element
                                   Provider #js {:value {:add-sticky     add-sticky
                                                         :remove-sticky  remove-sticky
                                                         :heights-before heights-before
                                                         :heights-after  heights-after
                                                         :scroll-to      scroll-to
                                                         :scroll-top     @*scroll-top
                                                         :scroll-height  @*scroll-height}}
                                   (r/as-element (into
                                                   [:div.overflow-y-scroll.relative
                                                    (merge props
                                                           {:onScroll on-update
                                                            ; Allow external refs in addition to the
                                                            ; internal one:
                                                            :ref      #(do
                                                                         (reset! *ref %)
                                                                         (when (fn? (:ref props))
                                                                           ((:ref props) %)))})]
                                                   children))))})))


(defn sticky [_ & _]
  (r/with-let [*ref (atom nil)]
    (r/create-class
      {:context-type           sticky-context
       :component-did-mount    #((-> (.-context %) :add-sticky) *ref)
       :component-will-unmount #((-> (.-context %) :remove-sticky) *ref)
       :reagent-render         (fn [props & children]
                                 (let [{:keys [heights-before
                                               heights-after
                                               scroll-top
                                               scroll-height
                                               scroll-to]}    (.-context (r/current-component))
                                       offset-top             (if (nil? @*ref) 0 (.-offsetTop @*ref))
                                       top-shift              (if (nil? @*ref) 0 (- offset-top (heights-before @*ref) scroll-top))
                                       btm-shift              (if (nil? @*ref) 0 (- (+ offset-top (heights-after @*ref)) scroll-top scroll-height))
                                       y                      (if (< top-shift 0) top-shift (if (> btm-shift 0) btm-shift 0))]
                                   (into [:div.relative
                                          (merge props
                                                 {:style    (merge {:will-change "transform"
                                                                    :transform   (str "translateY(" (* y -1) "px)")}
                                                                   (:style props))
                                                  :on-click #(do
                                                               (scroll-to (- offset-top (heights-before @*ref)))
                                                               (when (fn? (:on-click props))
                                                                 ((:on-click props))))
                                                            ; Allow external refs in addition to the
                                                            ; internal one:
                                                  :ref      #(do
                                                               (reset! *ref %)
                                                               (when (fn? (:ref props))
                                                                 ((:ref props) %)))})]
                                         children)))})))
